import styled from 'styled-components';

export const H1 = styled.h1`
  font-weight: bold;
  font-size: 48px;
  line-height: 120%;
  color: var(--primary);
  margin-bottom: 40px;
`;

export const Text = styled.p`
  font-size: 16px;
  line-height: 24px;
  color: var(--black-5);
`;

export const Label = styled.p`
  font-size: 14px;
  color: var(--gray-9);
  text-transform: uppercase;
  margin-bottom: 20px;
  font-weight: 500;
`;

export const H2 = styled.h2`
  font-weight: bold;
  font-size: 36px;
  color: var(--primary);
  margin-bottom: 24px;
`;

export const Skeleton = styled.div`
  border-radius: 20px;

  background: var(--white-darker);
  background-image: linear-gradient(
    to right,
    var(--white-darker) 0%,
    var(--gray-d) 20%,
    var(--white-darker) 40%,
    var(--white-darker) 100%
  );
  background-repeat: no-repeat;
  background-size: 800px 400px;
  display: inline-block;
  position: relative;

  animation: shimmer 1s forwards infinite linear;

  @keyframes shimmer {
    0% {
      background-position: -500px 0;
    }
    100% {
      background-position: 500px 0;
    }
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: var(--gray-d);
  margin: 30px 0;
`;

export const Spin = styled.div`
  width: 24px;
  height: 24px;
  opacity: 0.7;
  border: 3px solid var(--white);
  border-top: 3px solid transparent;
  border-radius: 50%;
  animation: 1s spin linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const NotFoundContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px 0;
  color: var(--gray-9);

  > svg {
    min-width: 24px;
    margin-right: 16px;
  }
`;

export const DeleteButton = styled.button`
  width: 100%;
  height: 60px;
  margin: 20px 0;
  color: var(--gray-9);
  font-weight: bold;
  font-size: 16px;
  background: none;
  cursor: pointer;

  display: flex;
  justify-content: center;
  align-items: center;

  > svg:first-child {
    margin-right: 8px;
  }
`;

export const Select = styled.select`
  width: 100%;
  height: 45px;
  font-size: 14px;
  padding: 10px 20px;
  color: var(--black-2);
  background: var(--white);
  border: 1px solid var(--gray-d);
  border-radius: 4px;
  outline: 0;
  transition: 0.2s ease-in-out;
  cursor: pointer;
  appearance: none;

  :focus {
    border: 1px solid var(--primary);
  }

  :disabled {
    background: var(--white-darker);
    cursor: not-allowed;
  }
`;

export const InputLabel = styled.label`
  font-weight: 500;
  font-size: 14px;
  line-height: 19px;
  color: var(--black-2);
`;

export const SelectContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  margin-top: 10px;
  position: relative;
`;

export const SelectIconWrapper = styled.div`
  height: 20px;
  width: 20px;
  position: absolute;
  bottom: 13px;
  pointer-events: none;
`;

export const BareInput = styled.input`
  width: 100%;
  height: 45px;
  font-size: 16px;
  padding: 15px 20px;
  color: var(--black-2);
  background: var(--white);
  border: 1px solid var(--gray-d);
  border-radius: 4px;
  margin-top: 10px;
  outline: 0;
  transition: box-shadow 0.2s ease-in-out;

  :focus {
    box-shadow: 0 0 0px 3px rgba(0, 0, 0, 0.1);
  }

  :disabled {
    background: var(--white-darker);
    cursor: not-allowed;
  }
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  [type='number'] {
    -moz-appearance: textfield;
  }
`;

export const SimpleButton = styled.button`
  width: 100%;
  height: 60px;
  color: var(--black-3);
  background: transparent;
  padding: 8px 16px;
  border: 0;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  outline: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  transition: background 0.2s ease;

  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  :hover {
    background: rgba(0, 0, 0, 0.05);
  }
`;

export const Tooltip = styled.div`
  background: var(--black-3);
  color: var(--white);
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 14px;

  position: relative;
`;
